export class PathUtils {
  private constructor() {}

  public static stripExtension(pathOrFileName: string): string {
    return pathOrFileName.replace(/\.[^./\\]*$/, '');
  }

  public static useSlashSeparators(path: string): string {
    return path.replace(/\\/g, '/');
  }

  public static joinPaths(...segments: Array<string>): string {
    let path = '';

    for (const [index, segment] of segments.entries()) {
      if (path.length && path[path.length - 1] !== '/') {
        path += '/';
      }

      if (index > 0) {
        const segmentWithoutLeadingSlash =
          /^[/]*(.*)$/.exec(segment)?.[1] ?? segment;
        path += segmentWithoutLeadingSlash;
      } else {
        path += segment;
      }
    }

    return path;
  }
}
